import { PublicAccountPaymentMethod } from "../types/public-accounts-api.types";
import type { NewPublicAccountFormData } from "../types/new-public-account.types";
import { getPaymentMethodFieldsForAccount } from "../constants/bankOptionsByCountry";
import { COUNTRY_CODE_TO_CURRENCY } from "../constants/public-accounts.constants";

function buildStructuredData(data: NewPublicAccountFormData): Record<string, unknown> {
  if (data.payment_method === PublicAccountPaymentMethod.BANK) {
    const payload: Record<string, unknown> = {
      bank_name: data.bank_name.trim(),
      account_type: data.account_type?.trim() ?? "",
      account_number: data.account_number?.trim() ?? "",
    };
    const methodFieldsConfig = getPaymentMethodFieldsForAccount(
      data.country_code,
      data.bank_name
    );
    const methodFields = data.methodFields ?? {};
    if (methodFieldsConfig.length > 0) {
      for (const field of methodFieldsConfig) {
        if (field.id === "tipoCuenta" || field.id === "numeroCuenta") {
          continue;
        }
        payload[field.id] = methodFields[field.id]?.trim() ?? "";
      }
    }
    return payload;
  }
  return {
    wallet_address: data.wallet_address.trim(),
    network: data.network.trim(),
  };
}

export function buildFormDataForPublicAccount(data: NewPublicAccountFormData): FormData {
  const formData = new FormData();
  const country_code = data.country_code.trim();
  const currency = (COUNTRY_CODE_TO_CURRENCY[country_code] ?? data.currency?.trim() ?? "").trim();
  formData.append("country_code", country_code);
  formData.append("currency", currency);
  formData.append("payment_method", data.payment_method);
  if (data.internal_alias?.trim()) {
    formData.append("internal_alias", data.internal_alias.trim());
  }
  if (data.notes?.trim()) {
    formData.append("notes", data.notes.trim());
  }
  const structuredData = buildStructuredData(data);
  formData.append("structured_data", JSON.stringify(structuredData));
  for (const file of data.attachments ?? []) {
    formData.append("attachments", file, file.name);
  }
  return formData;
}
